import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import Fruchtgummi from "../components/Fruchtgummi"
import Calender from "../components/elements/Calender"
import ListDays from "../components/elements/ListDays"
import CarouselCalender from "../components/elements/CarouselCalender"
import { updateIframeHeight } from "../helper"
import PromoSoonOverHandler from "../components/PromoSoonOverHandler"

const Home: React.FC = () => {
	useEffect(() => {
		updateIframeHeight()
		// eslint-disable-next-line
	}, [])

	return (
		<PromoSoonOverHandler>
			<div className="bg-[url('/src/bgimages/sun.jpg')] bg-no-repeat bg-cover bg-top">
				<section className="container max-w-xl ">
					<img src={process.env.PUBLIC_URL + "/images/nimm2header.png"} className=" w-full " alt="" />

					<div className="text-center mt-12 ">
						<Link to="/memory" className="btn">
							JETZT mitspielen!
						</Link>
					</div>
				</section>

				<div className="hidden md:block pb-6 sm:pb-12">
					<CarouselCalender />
				</div>
				<div className="block md:hidden pb-6 sm:pb-12 px-2">
					<Calender />
				</div>
			</div>

			<div className="contentGradient">
				<div className="container ">
					<h2 className="h2 py-6 sm:py-16">TÄGLICHE CHANCE AUF TOLLE GEWINNE</h2>

					<ListDays />
				</div>
				<div className="container ">
					<div className="text-center mt-6 sm:mt-16">
						<Link to="/memory#gewinne" className="btn">
							ALLE GEWINNE ENTDECKEN
						</Link>
						<p className="pt-6 md:pt-12">
							Weitere Informationen in den{" "}
							<Link to="teilnahmebedingungen" className="underline">
								Teilnahmebedingungen
							</Link>
							.
						</p>
					</div>
				</div>

				<Fruchtgummi />
			</div>
		</PromoSoonOverHandler>
	)
}
export default Home
